import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { LIST_IP_ADDRESS } from 'src/app/constants/endpoint.const';
import { IIpAddress } from 'src/app/models/integration.model';
import { ModalAddReferrerComponent } from '../modal-add-referrer/modal-add-referrer.component';
import { ModalDeleteReferrerComponent } from '../modal-delete-referrer/modal-delete-referrer.component';

@Component({
  standalone: false,
  selector: 'app-referrer-whitelist',
  templateUrl: './referrer-whitelist.component.html',
  styleUrls: ['./referrer-whitelist.component.scss'],
})
export class ReferrerWhitelistComponent implements OnInit {
  @Output() deleted = new EventEmitter<void>();

  destroy$ = new Subject();
  listIPAddress: IIpAddress[] = [];
  loading: boolean = true;

  constructor(
    private message: NzMessageService,
    private modalService: NgbModal,
    private baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.getListIP();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  getListIP() {
    this.baseService
      .getData(LIST_IP_ADDRESS)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.listIPAddress = res.data;
        },
        (err) => {
          this.message.create('error', 'Failed to get list Api Address');
          console.warn(err);
        }
      );
  }

  addReferrer() {
    const modal = this.modalService.open(ModalAddReferrerComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    });

    const modalInstance = modal.componentInstance as ModalAddReferrerComponent;

    modalInstance.addRef.subscribe(() => {
      this.getListIP();
    });
  }

  deleteReferrer(e: number, d: string) {
    const modal = this.modalService.open(ModalDeleteReferrerComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    const modalInstance =
      modal.componentInstance as ModalDeleteReferrerComponent;

    modal.componentInstance.idRef = e;
    modal.componentInstance.typeDevice = d;

    modalInstance.deleteRef.subscribe(() => {
      this.getListIP();
      this.deleted.emit();
    });
  }
}
